<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-02-25 18:12:54
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-17 10:56:04
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\components\handCardDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<!-- 上传手卡 -->
		<el-dialog width="480px" :title="title" :visible.sync="dialogUploadVisible" :append-to-body="true" @close="resetUpload">
			<div class="flex-column flex-just-around mt-16 ml-8">
				<el-radio v-model="radio" :label="0">使用自己上传的手卡</el-radio>
				<div class="flex flex-align-end ml-28 mt-24" v-show="!radio">
					<uploadImg @saveCardLink="saveCardLink" ref="uploadImg" :default_img="customCard" :key="customCard" class="mr-8"></uploadImg>
					<div>
						<p class="mt-10 flex flex-align-center">
							<span class="yx-color-info fz-13"
								>仅支持上传jpg、png格式，大小不超过10M的图片
								<el-tooltip content="PPT、PDF中的手卡可以另存为图片后再上传">
									<i class="iconfont icon-a-help-circle-obangzhu-xian pointer"></i>
								</el-tooltip>
							</span>
						</p>
					</div>
				</div>
				<el-radio v-model="radio" :label="1" class="mt-32">使用系统生成的手卡</el-radio>
				<div v-show="radio">
					<p class="ml-24 mt-8 yx-color-info">系统手卡被应用后会根据商品信息自动生成并更新</p>
					<Sysgen-img ref="SysgenImg" @succeedCard="succeedCard($event)" :key="dialogUploadVisible"></Sysgen-img>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取消</el-button>
				<el-button type="primary" @click="uploadHandCard">确定</el-button>
			</div>
		</el-dialog>
		<!-- 查看手卡 -->
		<el-dialog
			class="look-handcard"
			width="400px"
			title="查看手卡"
			:visible.sync="dialogLookCardVisible"
			:append-to-body="true"
			@close="resetFileList"
		>
			<el-upload action="#" list-type="picture-card" :file-list="fileList" :auto-upload="false" style="margin: 16px 0 16px 104px; width: 160px">
				<i slot="default" class="el-icon-plus"></i>
				<div slot="file" slot-scope="{ file }">
					<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
					<span class="el-upload-list__item-actions">
						<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
							<i class="el-icon-zoom-in"></i>
						</span>
						<span class="el-upload-list__item-delete" @click="handleDownload(file)">
							<i class="el-icon-download"></i>
						</span>
					</span>
				</div>
			</el-upload>
			<div class="demo-image__error mt-20 mb-20" v-if="isDelete">
				<div class="block">
					<el-image>
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline" style="font-size: 64px; color: #999"></i>
						</div>
					</el-image>
				</div>
				<span class="demonstration">暂无数据</span>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="lookHandSubmit">关闭</el-button>
				<el-button
					:loading="loading"
					type="primary"
					v-if="$auth.hasPermi('system:goods-switchHandcard') && hasReplaceHandCard"
					@click="replaceHandCard"
					>更换手卡</el-button
				>
			</div>
		</el-dialog>
		<preview-pictures :src="dialogImageUrl" v-if="dialogImgVisible" @close="dialogImgVisible = false" />
	</div>
</template>
<script>
import { checkImg } from '@/utils/validate';
import uploadImg from '@/components/common/uploadImg';
import SysgenImg from '@/components/common/sysgenImg';
import { getHandcard, setHandcard, syncProductSkuList } from '@/api/shopManage';
import previewPictures from '@/components/common/previewPictures';
export default {
	name: 'handCardDialog',
	props: {
		// 是否展示更换手卡按钮
		hasReplaceHandCard: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		uploadImg,
		SysgenImg,
		previewPictures,
	},
	data() {
		return {
			dialogUploadVisible: false,
			dialogLookCardVisible: false,
			fileList: [{ name: '商品手卡', url: '' }],
			shopObj: {},
			lookCardUrl: '',
			dialogImgVisible: false,
			dialogImageUrl: '',
			projectName: '',
			isDelete: 0,
			radio: 0,
			customCard: '', //保存手卡
			systemCard: '', //系统手卡
			handCardLink: '', //上传手卡
			title: '上传手卡',

			loading: false,
		};
	},
	methods: {
		// 上传手卡
		async handCard(row) {
			await this.asyncSkuList(row);
			this.shopObj = row;
			this.dialogUploadVisible = true;
			this.$nextTick(() => {
				this.$refs.SysgenImg.getImg(this.shopObj.product_id);
			});
		},
		async uploadHandCard() {
			const { handCardLink, radio: use_type, systemCard, title } = this;
			if ((!use_type && handCardLink) || (use_type && systemCard)) {
				let params = {
					product_id: this.shopObj.product_id,
					hand_card: use_type ? systemCard : handCardLink,
					use_type,
				};
				await setHandcard(params);
				this.$message.success(`${title}成功`);
				this.$refs.uploadImg.clearFiles();
				this.dialogUploadVisible = false;
				this.$emit('refreshList');
			} else {
				this.$message.error('请先选择图片');
			}
		},
		async asyncSkuList(row) {
			// 同步商品sku， 抖音更改了同步sku的限额，所以只能按需同步，使用哪个商品就调用同步哪个sku
			await syncProductSkuList({
				platformId: row.platform_id,
				productIds: [
					{
						outProductId: row.third_product_id,
						productId: row.product_id,
					},
				],
				source: dataMap.syncSkuSource.hand_card,
			});
		},
		succeedCard(val) {
			if (val) {
				this.systemCard = val;
			}
		},
		// 查看手卡
		async seeHandCard(row) {
			this.shopObj = row;
			await this.asyncSkuList(row);
			const { product_name, product_id } = row;
			this.projectName = product_name;
			const { custom_card, use_type, system_card } = await getHandcard({ product_id });
			this.$set(this.fileList[0], 'url', use_type === '1' ? system_card : custom_card);
			this.dialogLookCardVisible = true;
		},
		saveCardLink(val) {
			this.handCardLink = val;
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogImgVisible = true;
		},
		//重置
		resetUpload() {
			this.radio = 0;
			this.customCard = '';
			this.handCardLink = '';
			this.title = '上传手卡';
			this.$refs.uploadImg.clearFiles();
			this.$refs.SysgenImg.clearFiles();
		},
		resetFileList() {
			this.$set(this.fileList[0], 'url', '');
		},
		//更换手卡
		async replaceHandCard() {
			this.loading = true;
			this.title = '更换手卡';
			const { product_id } = this.shopObj;
			const { custom_card } = await getHandcard({ product_id });
			this.handCardLink = custom_card;
			this.customCard = custom_card;
			this.dialogLookCardVisible = false;
			this.dialogUploadVisible = true;
			this.loading = false;
			this.$nextTick(() => {
				this.$refs.SysgenImg.getImg(this.shopObj.product_id);
			});
		},
		lookHandSubmit() {
			if (!this.isDelete) {
				this.dialogLookCardVisible = false;
			} else {
				this.uploadHandCard('del');
			}
		},
		cancel() {
			this.dialogUploadVisible = false;
			this.resetUpload();
		},
		//点击下载图片
		handleDownload(file) {
			if (!checkImg(file.url)) {
				var a = document.createElement('a'); // 创建a标签
				a.style.display = 'none'; // 隐藏a标签
				a.href = file.url; // 文件下载地址
				a.setAttribute('download', this.projectName || '手卡'); // 设置a为下载属性，并设置下载文件名
				document.body.appendChild(a); // 将a标签插入到页面中
				a.click(); // 强制触发a便签的点击事件
				document.body.removeChild(a); // 移除a标
				return;
			}
			const image = new Image();
			image.setAttribute('crossOrigin', 'anonymous');
			var _this = this;
			image.onload = function () {
				var canvas = document.createElement('canvas');
				canvas.width = image.width;
				canvas.height = image.height;
				var context = canvas.getContext('2d');
				context.drawImage(image, 0, 0, image.width, image.height);
				var url = canvas.toDataURL('image/png'); //得到图片的base64编码数据
				var a = document.createElement('a'); // 生成一个a元素
				var event = new MouseEvent('click'); // 创建一个单击事件
				a.download = _this.projectName || 'photo'; // 设置图片名称
				a.href = url; // 将生成的URL设置为a.href属性
				a.dispatchEvent(event); // 触发a的单击事件
			};
			image.src = file.url;
		},
	},
};
</script>
<style lang="less" scoped>
.look-handcard {
	/deep/ .el-dialog__body {
		padding-top: 0;
	}

	/deep/ .el-upload--picture-card {
		display: none;
	}
	/deep/ .el-dialog__header {
		padding-top: 12px;
	}
	/deep/ .el-dialog__headerbtn {
		top: 17px !important;
	}
}

.demo-image__error {
	text-align: center;
}

/deep/ .el-radio__inner::after {
	background-color: #2475ff;
	width: 7px;
	height: 7px;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
	color: #1d2129 !important;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
	background: white;
}

/deep/ .el-upload--picture-card {
	width: 80px !important;
	height: 80px !important;
}

.iconfont {
	display: inline-block;
	position: relative;
	top: 1px;
}

.el-radio {
	font-weight: 400;
}
</style>
